import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout")({
    component: () => <ScenarioLayout />,
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.tool.scenario.title"),
        };
    },
});

function ScenarioLayout() {
    return <Outlet />;
}
